import axios from "axios";

//export const appServiceName = process.env.REACT_APP_AGPL_PRODUCTION_URL;      //production (AGPL)
//export const appServiceName = process.env.REACT_APP_RCS_PRODUCTION_URL;       //production (RCS)
// export const appServiceName = process.env.REACT_APP_DEMO_STAGING_URL;         //staging demo
// export const appServiceName = process.env.REACT_APP_MT_PRODUCTION_URL;        //production(mastana)
//export const appServiceName = process.env.REACT_APP_AVON_PRODUCTION_URL;      //production(avon)
// export const appServiceName = process.env.REACT_APP_ACP_STAGING_URL;      //production(ACP)
export const appServiceName = process.env.REACT_APP_ACP_PRODUCTION_URL;      //MAIN PRODUCTION(ACP)


// export const appServiceName = 'http://192.168.1.5:8000';                   //local
// export const appServiceName = process.env.REACT_APP_LOCAL_URL; //'http://localhost:8000';



class RestfulProvider {
  constructor() {
    this.setCommonHeaders();
  }
  setCommonHeaders = () => {
    const token = localStorage.getItem("adharshila_token");

    token &&
      (axios.defaults.headers.common["Authorization"] = `Bearer ${token}`);
  };

  makeCall = (url, data, axiosMethod) => {
    const header = {
      ...((url === "/api/print_invoice2" || url === "/api/print-order") && {
        responseType: "arraybuffer",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (localStorage.getItem("adharshila_token")) {
      this.setCommonHeaders();
    }

    return new Promise((resolve, reject) => {
      const response = axiosMethod(`${appServiceName}${url}`, data, header);

      response
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(
            error
            // ||
            // "Server is down, please check after some time !!"
          );
        });
    });
  };

  put = (url, data) => {
    return this.makeCall(url, data, axios.put);
  };

  post = (url, data) => {
    return this.makeCall(url, data, axios.post);
  };

  get = (url) => {
    return this.makeCall(url, undefined, axios.get);
  };

  delete = (url, request) => {
    return this.makeCall(url, { data: request }, axios.delete);
  };
}

export default new RestfulProvider();
